function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import DateTimePicker from '../common/controls/dateTimePicker';
import SinglePicker from '../common/controls/singlePicker';
import NumberInput from '../common/controls/numberInput';
import TextInput from '../common/controls/textInput';
class AssetProfile extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    const {
      assetColor,
      assetColorActions
    } = this.props;
    assetColorActions.serverIndex(assetColor.indexQuery);
  }
  handleChange(fieldName, value) {
    const {
      asset: {
        id: assetID
      },
      assetActions
    } = this.props;
    assetActions.change(assetID, fieldName, value);
  }
  render() {
    const {
      assetColor,
      asset
    } = this.props;
    const {
      year,
      purchaseDate,
      estimatedValue,
      assetColorID
    } = asset;

    // Convert the date value and propagate up
    const handleChangeYear = value => this.handleChange('year', value);
    const handleChangePurchaseDate = value => this.handleChange('purchaseDate', value);
    const handleChangeEstimatedValue = value => this.handleChange('estimatedValue', value);
    const handleChangeAssetColorID = value => this.handleChange('assetColorID', value);
    const textProps = {
      data: asset,
      onChange: this.handleChange,
      entity: 'Asset'
    };
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Profile"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, _objectSpread({
      label: "VIN / Serial",
      field: "serial"
    }, textProps))), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(DateTimePicker, {
      onChange: handleChangeYear,
      label: "Year",
      defaultValue: year
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, _objectSpread({
      label: "Manufacturer",
      field: "manufacturer"
    }, textProps))), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, _objectSpread({
      label: "Model",
      field: "model"
    }, textProps)))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(DateTimePicker, {
      onChange: handleChangePurchaseDate,
      label: "Purchase Date",
      defaultValue: purchaseDate
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: "Est. Value",
      value: estimatedValue,
      entity: "Asset",
      field: "estimatedValue",
      onChange: handleChangeEstimatedValue
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(TextInput, _objectSpread({
      label: "Plate / Reg #",
      field: "plateRegNumber"
    }, textProps))), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Color",
      labelKey: "name",
      onChange: handleChangeAssetColorID,
      options: assetColor.list,
      placeholder: "Select...",
      value: assetColorID,
      returnValueKey: "id",
      searchable: false
    }))));
  }
}
AssetProfile.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string,
    assetColorID: PropTypes.string,
    estimatedValue: PropTypes.number,
    purchaseDate: PropTypes.string,
    year: PropTypes.string,
    serial: PropTypes.string
  }).isRequired,
  assetActions: PropTypes.shape({
    change: PropTypes.func,
    handleChange: PropTypes.func
  }).isRequired,
  assetColor: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetColorActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired
};
export { AssetProfile as TestAssetProfile };
export default entityComposition(AssetProfile, ['assetColor']);